import * as countriesActions from "stores/actions/countries";
import Http from "utils/Http";
import * as authActions from "stores/actions/auth";

export function fetchCountries() {
  return dispatch =>
    new Promise((resolve, reject) => {
      let url = "countries";
      Http.get(url)
        .then(res => {
          dispatch(countriesActions.fetchCountriesResolved(res.data));
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}
